let view = null;

export default {
	namespace: 'template-advanced-page',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: AdvancedView } = await import(
			/* webpackChunkName: "advanced-view" */ '../../templates/AdvancedView'
		);
		view = new AdvancedView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
